import { fetchAsObservable } from 'fetcher!sofe';
import { pluck } from 'rxjs/operators';

export function getPaymentsStatus() {
  return fetchAsObservable(`api/canopy_payments/status`).pipe(pluck('status'))
}
